import { useDispatch } from 'react-redux';
import { RetrieveCountriesInputDto, RetrieveCountriesOutputDto } from '@api/izibizi-xp';
import { useFetch } from '@hooks';
import { saveSuccessServiceResponse } from '@store';
import { UseFetchHookOutput } from '@bcp-channels-sharedcomponents-reactjs/core/dist/$hooks';

export const useFetchRetrieveCountries = (): UseFetchHookOutput<
	Omit<RetrieveCountriesInputDto, 'metadata'>,
	RetrieveCountriesOutputDto
> => {
	const dispatch = useDispatch();

	return useFetch<RetrieveCountriesInputDto, RetrieveCountriesOutputDto>({
		operationKey: 'retrieveCountries',
		onSuccess: (res) => {
			if (res.data) {
				dispatch(saveSuccessServiceResponse({ retrieveCountries: res.data }));
			}
		},
	});
};
